function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66665 11.6667V11H4.00665L3.99998 13.6667C3.99998 14.4067 4.59331 15 5.33331 15H14.6666C15.4066 15 16 14.4067 16 13.6667V11H11.3333V11.6667H8.66665ZM15.3333 5.66667H12.66V4.33333L11.3266 3H8.65998L7.32665 4.33333V5.66667H4.66665C3.93331 5.66667 3.33331 6.26667 3.33331 7V9C3.33331 9.74 3.92665 10.3333 4.66665 10.3333H8.66665V9H11.3333V10.3333H15.3333C16.0666 10.3333 16.6666 9.73333 16.6666 9V7C16.6666 6.26667 16.0666 5.66667 15.3333 5.66667ZM11.3333 5.66667H8.66665V4.33333H11.3333V5.66667Z",
  fill: "#5C71DA"
});

var SvgWork = function SvgWork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/work.64b2a4e3.svg";
export { ForwardRef as ReactComponent };